/* Saint Texas — "Customize This Hat" link behaviour.

   Extracted from blocks/st-customize-cta.liquid so the same logic can run in
   places the block's own inline script cannot: Horizon's quick-add modal
   injects product markup with innerHTML/morph, and injected <script> tags
   never execute. This file is loaded site-wide and claims any .st-cta-block
   that appears, now or later.

   What it does for each block:
     - carries unpublished-theme preview params onto the link
     - follows the variant picker, so the builder opens on the chosen colour
     - builds the whole link from scratch when there isn't a usable one yet
       (the quick-add modal case, where st-quick-add.js creates a bare block) */
(function () {
  "use strict";
  if (window.__stCustomizeCtaLoaded) return;
  window.__stCustomizeCtaLoaded = true;

  var PREVIEW_KEYS = ["preview_theme_id", "_fd", "_ab", "_sc"];
  var productCache = {};

  // Our true cost for a colourway's blank. The Ajax product JSON has no
  // metafields, so the block carries the SKU -> cost map (custom.blank_costs)
  // and the cheapest colourway (custom.blank_cost_min) as data attributes.
  // Returns null when neither is present, and the caller then leaves whatever
  // cost Liquid already put on the link alone instead of guessing from the
  // list price.
  function blankCostFor(block, variant) {
    var raw = block.getAttribute("data-blank-costs");
    if (raw) {
      try {
        var map = JSON.parse(raw);
        if (map && variant && variant.sku && map[variant.sku] != null) return Number(map[variant.sku]);
      } catch (e) { /* fall through to the minimum */ }
    }
    var min = parseFloat(block.getAttribute("data-blank-cost-min"));
    return isNaN(min) ? null : min;
  }

  function carryPreviewParams(url) {
    var current = new URLSearchParams(window.location.search);
    PREVIEW_KEYS.forEach(function (key) {
      if (current.has(key) && !url.searchParams.has(key)) url.searchParams.set(key, current.get(key));
    });
  }

  function getProduct(productUrl) {
    if (!productUrl) return Promise.reject(new Error("no product url"));
    var key = productUrl.split("?")[0];
    if (productCache[key]) return Promise.resolve(productCache[key]);
    return fetch(key + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (p) { productCache[key] = p; return p; });
  }

  function imageParam(src) {
    if (!src) return null;
    var abs = src.indexOf("//") === 0 ? "https:" + src : src;
    return abs + (abs.indexOf("?") === -1 ? "?" : "&") + "width=1200";
  }

  // The variant the shopper currently has selected inside this block's picker.
  function selectedVariant(block, product) {
    var scope = block.closest(".product-details") || block.closest("[data-product-grid-content]") || document;
    var picker = scope.querySelector("variant-picker");
    if (!picker) return null;
    var checked = Array.prototype.slice.call(picker.querySelectorAll('input[type="radio"]:checked'));
    if (!checked.length) return null;

    var byId = null;
    checked.forEach(function (i) { if (!byId && i.dataset && i.dataset.variantId) byId = i.dataset.variantId; });

    var values = checked.map(function (i) { return i.value; });
    var match = null;
    (product.variants || []).forEach(function (v) {
      if (match) return;
      if (values.length && values.every(function (val, idx) { return v.options[idx] === val; })) match = v;
    });
    if (!match && byId) {
      (product.variants || []).forEach(function (v) { if (!match && String(v.id) === String(byId)) match = v; });
    }
    return match;
  }

  function apply(link, url) {
    link.href = url.pathname + "?" + url.searchParams.toString();
  }

  function refresh(block) {
    var link = block.querySelector(".st-cta-block__btn");
    var productUrl = block.getAttribute("data-product-url");
    if (!link || !productUrl) return;

    getProduct(productUrl).then(function (product) {
      var v = selectedVariant(block, product) || product.variants[0];
      if (!v) return;

      var base = block.getAttribute("data-builder-url") || link.getAttribute("href") || "";
      var url;
      try {
        url = new URL(base, window.location.origin);
      } catch (e) {
        return;
      }
      url.searchParams.set("variant_id", v.id);
      var cost = blankCostFor(block, v);
      if (cost !== null) {
        url.searchParams.set("cost", cost.toString());
        url.searchParams.delete("price");
      }
      url.searchParams.set("title", product.title);
      url.searchParams.set("handle", product.handle);
      var img = imageParam(v.featured_image ? v.featured_image.src : product.featured_image);
      if (img) url.searchParams.set("image", img);
      carryPreviewParams(url);
      apply(link, url);
    }).catch(function () { /* leave the server-rendered href alone */ });
  }

  function init(block) {
    if (block.__stCtaReady) return;
    block.__stCtaReady = true;

    var link = block.querySelector(".st-cta-block__btn");
    if (link && link.getAttribute("href") && link.getAttribute("href") !== "#") {
      // Server-rendered link: it is already correct for the current variant,
      // it just needs the preview params so it stays on the dev theme.
      try {
        var url = new URL(link.href, window.location.origin);
        carryPreviewParams(url);
        apply(link, url);
      } catch (e) { /* ignore */ }
    } else {
      refresh(block);
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(".st-cta-block"), init);
  }

  // Horizon swaps variants without a reload, in the product page and in the
  // quick-add modal alike, so every block re-resolves on any picker change.
  document.addEventListener("change", function (e) {
    if (!(e.target && e.target.closest && e.target.closest("variant-picker"))) return;
    Array.prototype.forEach.call(document.querySelectorAll(".st-cta-block"), refresh);
  });

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.classList && n.classList.contains("st-cta-block")) init(n);
        else if (n.querySelector && n.querySelector(".st-cta-block")) initAll(n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  else initAll(document);

  window.stCustomizeCta = { init: init, initAll: initAll, refresh: refresh };
})();
